<template>
	<div class="search-output" :class="{'is-last-minute': isLastMinute === true}">
		<div v-if="hasSearchTop" class="search-top searchTopBottom" :class="{'force-top':forceSearchTop}"><slot name="search-top"></slot></div>
		<template v-if="lodgings.length > 0">
			<feriehus-item v-for="(lodging, index) in lodgings" :key="lodging.position" :lodging="lodging" :displayLastMinuteHeader="displayLastMinuteHeader(index)" />
		</template>
		<no-results v-else/>
	</div>
</template>

<script>
	import FeriehusItem from "@vue/components/search/FeriehusItem.vue";
	import NoResults from "@vue/components/search/NoResults.vue";
	import {mapState} from 'vuex';
	import {triggerDocumentEvent} from "@js/globalFunctions/events";
	export default {
		name: "searchOutput",
		data(){
			return {
				shownLodgings: []
			}
		},
		components: {
			FeriehusItem,
			NoResults
		},
		computed: {
			...mapState({
				lodgings: 'lodgings',
				isLastMinute: 'isLastMinute',
			}),
			hasSearchTop(){
				return !!this.$slots['search-top']
			}
		},
		methods: {
			displayLastMinuteHeader(index)
			{
				if(this.isLastMinute !== true)
					return false;
				
				if(index === 0)
					return true;
				
				return (this.lodgings[index-1]['datestring'] !== this.lodgings[index]['datestring'] || this.lodgings[index-1]['duration'] !== this.lodgings[index]['duration']);
			},
		},
		mounted() {
			this.$nextTick(() => {
				triggerDocumentEvent('searchOutputHasMounted')
			})
		},
		props: {
			forceSearchTop: {
				type: Boolean,
				default: false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.force-top{
		display: block !important;
	}
</style>
